var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFengsufengxiangyi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arcticons:wire"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 561",
    d: "M8 6L10 6",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 562",
    d: "M7.77639 6.44721C8.02338 6.57071 8.32372 6.4706 8.44721 6.22361C8.57071 5.97662 8.4706 5.67628 8.22361 5.55279L7.77639 6.44721ZM1.77639 3.44721L7.77639 6.44721L8.22361 5.55279L2.22361 2.55279L1.77639 3.44721Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631278",
    x: 10.5,
    y: 4.5,
    width: 4,
    height: 4,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631280",
    x: 1.5,
    y: 1.5,
    width: 4,
    height: 4,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 563",
    d: "M8 6V16",
    stroke: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFengsufengxiangyi);
export default __webpack_public_path__ + "static/media/fengsufengxiangyi.75137d4bca90566258b102993a03ae84.svg";
export { ForwardRef as ReactComponent };